var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import REMOVE_WAREHOUSE_RELEASE_MODEL from 'api/mutations/REMOVE_WAREHOUSE_RELEASE_MODEL';
import SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE from 'api/mutations/SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE';
import SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_NOT_READY from 'api/mutations/SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_NOT_READY';
import SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_READY from 'api/mutations/SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_READY';
import SET_WAREHOUSE_RELEASE_MODEL_TO_NOT_READY from 'api/mutations/SET_WAREHOUSE_RELEASE_MODEL_TO_NOT_READY';
import SET_WAREHOUSE_RELEASE_MODEL_TO_READY from 'api/mutations/SET_WAREHOUSE_RELEASE_TO_READY';
import UPDATE_WAREHOUSE_RELEASE_MODEL_SPECIFICATION from 'api/mutations/UPDATE_WAREHOUSE_REELASE_MODEL_SPECIFICATION';
import UPDATE_WAREHOUSE_RELEASE_APPROVE from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_APPROVE';
import UPDATE_WAREHOUSE_RELEASE_CANCEL from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_CANCEL';
import UPDATE_WAREHOUSE_RELEASE_COMPLETE from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_COMPLETE';
import UPDATE_WAREHOUSE_RELEASE_MODEL_VARIANT from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_MODEL_VARIANT';
import GET_WAREHOUSE_RELEASE from 'api/queries/GET_WAREHOUSE_RELEASE';
import GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS from 'api/queries/GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS';
import GET_WAREHOUSE_RELEASE_MODEL from 'api/queries/GET_WAREHOUSE_RELEASE_MODEL_VARIANTS';
import client from '../api/environment';
const initialState = {
    item: null,
    itemModel: null,
    itemComponents: null,
    status: {
        fetch: 'idle',
        fetchReady: 'idle',
        add: 'idle',
        remove: 'idle',
        complete: 'idle',
        cancel: 'idle',
        fetchModel: 'idle',
        fetchComponents: 'idle',
    },
    errors: {
        fetch: null,
        fetchReady: null,
        add: null,
        remove: null,
        complete: null,
        cancel: null,
        fetchModel: null,
        fetchComponents: null,
    },
    refetchFlags: {
        fetch: false,
        fetchReady: false,
        add: false,
        remove: false,
        complete: false,
        cancel: false,
        fetchModel: false,
        fetchComponents: false,
    },
};
export const fetchWarehouseRelease = createAsyncThunk('warehouseReleaseDetails/fetchWarehouseRelease', (warehouseReleaseId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_WAREHOUSE_RELEASE,
            variables: {
                id: warehouseReleaseId,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchWarehouseReleaseIsReady = createAsyncThunk('warehouseReleaseDetails/fetchWarehouseReleaseIsReady', (warehouseReleaseId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_WAREHOUSE_RELEASE,
            variables: {
                id: warehouseReleaseId,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchWarehouseReleaseModel = createAsyncThunk('warehouseReleaseDetails/fetchWarehouseReleaseModel', (warehouseReleaseModelId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_WAREHOUSE_RELEASE_MODEL,
            variables: {
                id: warehouseReleaseModelId,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.node;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchWarehouseReleaseComponents = createAsyncThunk('warehouseReleaseDetails/fetchWarehouseReleaseComponents', (warehouseReleaseId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS,
            variables: {
                id: warehouseReleaseId,
            },
            fetchPolicy: 'network-only',
        });
        return {
            allComponentVariantsReady: response.data.node.allComponentVariantsReady,
            components: response.data.node.componentVariantsByCategories,
        };
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const addWarehouseReleaseModel = createAsyncThunk('warehouseReleaseDetails/addWarehouseReleaseModel', ({ warehouseReleaseId, modelSpecificationId, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const warehouseReleaseModelData = yield client.mutate({
            mutation: UPDATE_WAREHOUSE_RELEASE_MODEL_SPECIFICATION,
            variables: {
                modelSpecificationId,
                warehouseReleaseId,
            },
        });
        return {
            id: warehouseReleaseModelData.data.setWarehouseReleaseModel.warehouseReleaseModel.id,
            modelSpecificationNode: {
                id: modelSpecificationId,
            },
        };
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const removeWarehouseReleaseModel = createAsyncThunk('warehouseReleaseDetails/removeWarehouseReleaseModel', ({ warehouseReleaseModelId }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: REMOVE_WAREHOUSE_RELEASE_MODEL,
            variables: {
                warehouseReleaseModelId,
            },
        });
        return warehouseReleaseModelId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const approveWarehouseRelease = createAsyncThunk('warehouseReleaseDetails/approveWarehouseRelease', (warehouseReleaseNodeId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: UPDATE_WAREHOUSE_RELEASE_APPROVE,
            variables: {
                warehouseReleaseNodeId,
            },
        });
        return warehouseReleaseNodeId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const completeWarehouseRelease = createAsyncThunk('warehouseReleaseDetails/completeWarehouseRelease', (warehouseReleaseNodeId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: UPDATE_WAREHOUSE_RELEASE_COMPLETE,
            variables: {
                warehouseReleaseNodeId,
            },
        });
        return warehouseReleaseNodeId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const cancelWarehouseRelease = createAsyncThunk('warehouseReleaseDetails/cancelWarehouseRelease', (warehouseReleaseNodeId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: UPDATE_WAREHOUSE_RELEASE_CANCEL,
            variables: {
                warehouseReleaseNodeId,
            },
        });
        return warehouseReleaseNodeId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const updateWarehouseReleaseModelVariant = createAsyncThunk('warehouseReleaseDetails/updateWarehouseReleaseModelVariant', ({ variantId, value }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const warehouseReleaseModelData = yield client.mutate({
            mutation: UPDATE_WAREHOUSE_RELEASE_MODEL_VARIANT,
            variables: {
                variantsQuantity: [[variantId, value]],
            },
        });
        return warehouseReleaseModelData.data.updateWarehouseReleaseModelVariant
            .warehouseReleaseModelVariant.id;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setWarehouseReleaseModelToReady = createAsyncThunk('warehouseReleaseDetails/setWarehouseReleaseModelToReady', (warehouseReleaseModelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: SET_WAREHOUSE_RELEASE_MODEL_TO_READY,
            variables: {
                warehouseReleaseModelId,
            },
        });
        return warehouseReleaseModelId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setWarehouseReleaseModelToNotReady = createAsyncThunk('warehouseReleaseDetails/setWarehouseReleaseModelToNotReady', (warehouseReleaseModelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: SET_WAREHOUSE_RELEASE_MODEL_TO_NOT_READY,
            variables: {
                warehouseReleaseModelId,
            },
        });
        return warehouseReleaseModelId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setWarehouseReleaseComponentVariantConsumptionOverride = createAsyncThunk('warehouseReleaseDetails/setWarehouseReleaseComponentVariantConsumptionOverride', ({ warehouseReleaseComponentVariantId, value, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE,
            variables: {
                warehouseReleaseComponentVariantId,
                value,
            },
        });
        return warehouseReleaseComponentVariantId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setWarehouseReleaseComponentVariantToReady = createAsyncThunk('warehouseReleaseDetails/setWarehouseReleaseComponentVariantToReady', (warehouseReleaseComponentVariantId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_READY,
            variables: {
                warehouseReleaseComponentVariantId,
            },
        });
        return warehouseReleaseComponentVariantId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
export const setWarehouseReleaseComponentVariantToNotReady = createAsyncThunk('warehouseReleaseDetails/setWarehouseReleaseComponentVariantToNotReady', (warehouseReleaseComponentVariantId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.mutate({
            mutation: SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_NOT_READY,
            variables: {
                warehouseReleaseComponentVariantId,
            },
        });
        return warehouseReleaseComponentVariantId;
    }
    catch (error) {
        const apolloError = error;
        return apolloError.message;
    }
}));
const warehouseReleaseDetailsSlice = createSlice({
    name: 'warehouseReleaseDetails',
    initialState,
    reducers: {
        resetWarehouseReleaseDetailsState(state) {
            state.item = null;
            state.itemModel = null;
            state.itemComponents = null;
            state.status = initialState.status;
            state.errors = initialState.errors;
            state.refetchFlags = initialState.refetchFlags;
        },
        setWarehouseReleaseDetailsRefetchFlag(state, action) {
            state.refetchFlags.fetch = action.payload;
        },
        updateWarehouseReleaseSummary: (state, action) => {
            state.item[action.payload.name] = action.payload.value;
        },
        updateWarehouseReleaseModelVariantStore: (state, action) => {
            const { variantId, value } = action.payload;
            state.itemModel.variants.edges = state.itemModel.variants.edges.map((variant) => variant.node.id === variantId
                ? Object.assign(Object.assign({}, variant), { node: Object.assign(Object.assign({}, variant.node), { quantity: value }) }) : variant);
        },
        updateWarehouseReleaseComponentVariantStore: (state, action) => {
            const { warehouseReleaseComponentVariantId, value } = action.payload;
            state.itemComponents.components = state.itemComponents.components.map((category) => {
                return Object.assign(Object.assign({}, category), { componentVariants: category.componentVariants.map((variant) => variant.id === warehouseReleaseComponentVariantId
                        ? Object.assign(Object.assign({}, variant), { consumptionOverride: value }) : variant) });
            });
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWarehouseRelease.pending, (state) => {
            state.status.fetch = 'loading';
        })
            .addCase(fetchWarehouseRelease.fulfilled, (state, action) => {
            state.status.fetch = 'succeeded';
            state.item = action.payload;
            state.refetchFlags.fetch = false;
            state.refetchFlags.fetchModel = true;
            state.refetchFlags.fetchComponents = true;
        })
            .addCase(fetchWarehouseRelease.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchWarehouseReleaseIsReady.pending, (state) => {
            state.status.fetchReady = 'loading';
        })
            .addCase(fetchWarehouseReleaseIsReady.fulfilled, (state, action) => {
            state.status.fetchReady = 'succeeded';
            state.item.allComponentVariantsReady = action.payload.allComponentVariantsReady;
            state.item.sumOfModelQuantities = action.payload.sumOfModelQuantities;
            state.itemModel.ready = action.payload.warehouseReleaseModel.ready;
            state.refetchFlags.fetchReady = false;
        })
            .addCase(fetchWarehouseReleaseIsReady.rejected, (state, action) => {
            state.status.fetchReady = 'failed';
            state.errors.fetch =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchWarehouseReleaseModel.pending, (state) => {
            state.status.fetchModel = 'loading';
        })
            .addCase(fetchWarehouseReleaseModel.fulfilled, (state, action) => {
            state.status.fetchModel = 'succeeded';
            state.itemModel = action.payload;
            state.refetchFlags.fetchModel = false;
        })
            .addCase(fetchWarehouseReleaseModel.rejected, (state, action) => {
            state.status.fetchModel = 'failed';
            state.errors.fetchModel =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetchModel = false;
        })
            .addCase(fetchWarehouseReleaseComponents.pending, (state) => {
            state.status.fetchComponents = 'loading';
        })
            .addCase(fetchWarehouseReleaseComponents.fulfilled, (state, action) => {
            state.status.fetchComponents = 'succeeded';
            state.itemComponents = action.payload;
            state.refetchFlags.fetchComponents = false;
        })
            .addCase(fetchWarehouseReleaseComponents.rejected, (state, action) => {
            state.status.fetchComponents = 'failed';
            state.errors.fetchComponents =
                action.payload || 'Failed to fetch specification components';
            state.refetchFlags.fetchComponents = false;
        })
            .addCase(addWarehouseReleaseModel.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(addWarehouseReleaseModel.fulfilled, (state) => {
            state.status.add = 'succeeded';
            state.refetchFlags.fetch = true;
        })
            .addCase(addWarehouseReleaseModel.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(removeWarehouseReleaseModel.pending, (state) => {
            state.status.remove = 'loading';
        })
            .addCase(removeWarehouseReleaseModel.fulfilled, (state) => {
            state.status.remove = 'succeeded';
            state.item.warehouseReleaseModel = null;
            state.itemModel = null;
            state.itemComponents = null;
        })
            .addCase(removeWarehouseReleaseModel.rejected, (state, action) => {
            state.status.remove = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(approveWarehouseRelease.pending, (state) => {
            state.status.approve = 'loading';
        })
            .addCase(approveWarehouseRelease.fulfilled, (state) => {
            state.status.approve = 'succeeded';
            state.item.status = 'APPROVED';
        })
            .addCase(approveWarehouseRelease.rejected, (state, action) => {
            state.status.approve = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(completeWarehouseRelease.pending, (state) => {
            state.status.approve = 'loading';
        })
            .addCase(completeWarehouseRelease.fulfilled, (state) => {
            state.status.approve = 'succeeded';
            state.item.status = 'DONE';
        })
            .addCase(completeWarehouseRelease.rejected, (state, action) => {
            state.status.approve = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(cancelWarehouseRelease.pending, (state) => {
            state.status.cancel = 'loading';
        })
            .addCase(cancelWarehouseRelease.fulfilled, (state) => {
            state.status.cancel = 'succeeded';
            state.item.status = 'CANCELLED';
        })
            .addCase(cancelWarehouseRelease.rejected, (state, action) => {
            state.status.cancel = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(updateWarehouseReleaseModelVariant.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(updateWarehouseReleaseModelVariant.fulfilled, (state) => {
            state.status.other = 'succeeded';
        })
            .addCase(updateWarehouseReleaseModelVariant.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(setWarehouseReleaseModelToReady.pending, (state) => {
            state.status.other = 'loading';
        })
            .addCase(setWarehouseReleaseModelToReady.fulfilled, (state) => {
            state.status.other = 'succeeded';
            state.item.warehouseReleaseModel.ready = true;
            state.itemModel.ready = true;
            state.refetchFlags.fetchReady = true;
            state.refetchFlags.fetchComponents = true;
            state.status.fetchComponents = 'idle';
        })
            .addCase(setWarehouseReleaseModelToReady.rejected, (state, action) => {
            state.status.other = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(setWarehouseReleaseModelToNotReady.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(setWarehouseReleaseModelToNotReady.fulfilled, (state) => {
            state.status.add = 'succeeded';
            state.item.warehouseReleaseModel.ready = false;
            state.itemModel.ready = false;
            state.refetchFlags.fetchReady = true;
        })
            .addCase(setWarehouseReleaseModelToNotReady.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(setWarehouseReleaseComponentVariantToReady.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(setWarehouseReleaseComponentVariantToReady.fulfilled, (state, action) => {
            state.status.add = 'succeeded';
            state.itemComponents.components = state.itemComponents.components.map((component) => (Object.assign(Object.assign({}, component), { componentVariants: component.componentVariants.map((variant) => variant.id === action.payload ? Object.assign(Object.assign({}, variant), { ready: true }) : variant) })));
            state.refetchFlags.fetchReady = true;
        })
            .addCase(setWarehouseReleaseComponentVariantToReady.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        })
            .addCase(setWarehouseReleaseComponentVariantToNotReady.pending, (state) => {
            state.status.add = 'loading';
        })
            .addCase(setWarehouseReleaseComponentVariantToNotReady.fulfilled, (state, action) => {
            state.status.add = 'succeeded';
            state.itemComponents.components = state.itemComponents.components.map((component) => (Object.assign(Object.assign({}, component), { componentVariants: component.componentVariants.map((variant) => variant.id === action.payload ? Object.assign(Object.assign({}, variant), { ready: false }) : variant) })));
            state.refetchFlags.fetchReady = true;
        })
            .addCase(setWarehouseReleaseComponentVariantToNotReady.rejected, (state, action) => {
            state.status.add = 'failed';
            state.errors.add = action.error.message || 'Failed to add specification';
        });
    },
});
export const { resetWarehouseReleaseDetailsState, setWarehouseReleaseDetailsRefetchFlag, updateWarehouseReleaseSummary, updateWarehouseReleaseModelVariantStore, updateWarehouseReleaseComponentVariantStore, } = warehouseReleaseDetailsSlice.actions;
export const selectWarehouseReleaseDetailsStatus = (state) => state.warehouseReleaseDetails.status;
export const selectWarehouseReleaseDetailsErrors = (state) => state.warehouseReleaseDetails.errors;
export const selectWarehouseReleaseDetailsRefetchFlags = (state) => state.warehouseReleaseDetails.refetchFlags;
export const selectWarehouseReleaseDetailsItem = (state) => state.warehouseReleaseDetails.item;
export const selectWarehouseReleaseModel = (state) => state.warehouseReleaseDetails.itemModel;
export const selectWarehouseReleaseComponents = (state) => state.warehouseReleaseDetails.itemComponents;
export const selectIsModelAssigned = (id) => createSelector((state) => state.warehouseReleaseDetails.itemModel, (itemModel) => itemModel.modelSpecificationNode.id === id);
export const selectModelAssignedId = () => createSelector((state) => state.warehouseReleaseDetails.itemModel, (itemModel) => itemModel.modelSpecificationNode.id);
export default warehouseReleaseDetailsSlice.reducer;
